import { useCallback } from "react";

import { MONOLITH_ORIGIN } from "@/monolithIntegration/monolithIntegration.constants";
import useRestMutation from "@/remoteState/useRestMutation";

const useEventRecordPost = () => {
  const createEventRecordRequest = useCallback((payload) => {
    const requestConfig = {
      method: "POST",
      body: JSON.stringify(payload),
      headers: { "Content-Type": "application/json" },
    };

    return new Request(
      `${MONOLITH_ORIGIN}/api/v2/event-record/`,
      requestConfig,
    );
  }, []);
  return useRestMutation(createEventRecordRequest);
};

export default useEventRecordPost;
